import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Navigation from './Navigation';
import Footer from './Footer';
import Logo from './Logo';

const PageWrapper = ({ children }) => (
  <div className="page-wrapper">
    {/* Combined Header with Logo and Navigation */}
    <header className="app-header" data-testid="app-header">
      <div className="header-container">
        {/* Logo Section - Left */}
        <Link to="/" className="header-logo-link" data-testid="header-logo">
          <Logo size={40} />
          <div className="header-brand">
            <span className="brand-name">Uro2Go</span>
            <span className="brand-tagline">Patient Education</span>
          </div>
        </Link>

        {/* Navigation - Right */}
        <Navigation />
      </div>
    </header>

    <main className="page-content">
      {children}
    </main>
    <Footer />
  </div>
);

export default PageWrapper;
